import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Icon } from "antd";
import { withTranslation } from "react-i18next";

import Button from "../components/Button";

import styled from "styled-components/macro";

const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme["@grey"]};
  flex: 1;
`;

const Title = styled.h1`
  margin: 0 auto;
  margin-top: 20px;
`;

const Subtitle = styled.div`
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 32px;
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, eventId: null };
  }

  componentDidCatch(error) {
    this.setState({ error });
  }

  render() {
    const { children, t } = this.props;
    if (this.state.error) {
      return (
        <Container>
          <Icon
            type="exclamation-circle"
            style={{ fontSize: "90px", color: "#D8D8D8" }}
          />
          <Title>{t("global:errorTitleBoundary")}</Title>
          <Subtitle>{t("global:errorSubtitleBoundary")}</Subtitle>
          <Button
            className="go-back-btn"
            type="primary"
            onClick={() => window.location.replace("/")}
          >
            {t("global:backToWorcket")}
          </Button>
        </Container>
      );
    }
    return children;
  }
}

const enhancer = compose(
  withTranslation(["global"]),
  connect(
    state => ({
      user: state.user
    }),
    null
  )
);

export default enhancer(ErrorBoundary);
